<template>
  <div class="w-full">
    <!--div class="steps-header" :class="[extraClass]">
      <div class="container">
        <div class="row no-gutters steps-header-title-container-row justify-content-between">
          <div class="col-12 col-md-9 title-program-col d-md-flex d-flex flex-row">
            <div class="row step-header-container flex-row">
              <div class="number-indicator-container">
                <div class="step-container-number">
                  <span class="current-step">{{currentStep}}</span>
                </div>
              </div>
              <div class="text-step-container">
                <div class="d-md-flex d-flex justify-content-start align-items-center text-step-inner-container">
                  <p class="text-step-header">{{getStepText}}<span class="programs" v-if="currentStep === 1">programas asociados</span></p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-8 step-line-numbers">
            <div class="steps-container">
              <div class="steps-lines-container">
                <div
                  class="step-line"
                  :class="{ 'completed-line': step.status === 'completed' }"
                  v-for="(step, index) in steps"
                  :key="index"
                ></div>
              </div>
              <div
                class="steps-index-container d-flex justify-content-between align-items-center"
              >
                <div
                  class="step-index"
                  :class="{
                    active: step.status === 'active',
                    completed: step.status === 'completed'
                  }"
                  v-for="(step, index) in steps"
                  :key="index"
                >
                  <div class="step-index-box">
                    <span>{{ index + 1 }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div-->

    <div class="steps-recomendador">
      <div class="pdv-container">
        <div class="content-steps only-mobile">
          <svg
            width="308"
            height="4"
            viewBox="0 0 308 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="74"
              height="4"
              rx="2"
              :fill="currentStep >= 1 ? '#592466' : '#B5B6BA'"
            />
            <rect
              x="78"
              width="74"
              height="4"
              rx="2"
              :fill="currentStep >= 2 ? '#592466' : '#B5B6BA'"
            />
            <rect
              x="156"
              width="74"
              height="4"
              rx="2"
              :fill="currentStep >= 3 ? '#592466' : '#B5B6BA'"
            />
            <!--rect x="234" width="74" height="4" rx="2" :fill="currentStep === 4 ? '#592466' : '#B5B6BA'"/-->
          </svg>
          <div class="steps-data">
            <span class="steps-data-text">{{ currentStep }}/</span>
            <span class="steps-data-text grey" style="margin-right: 3px"
              >3</span
            >
            <span class="steps-data-text"> {{ getStepName }}</span>
          </div>
        </div>

        <div class="content-steps only-desktop">
          <svg
            width="500"
            height="4"
            viewBox="0 0 500 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="122"
              height="4"
              rx="2"
              :fill="currentStep >= 1 ? '#592466' : '#B5B6BA'"
            />
            <rect
              x="126"
              width="122"
              height="4"
              rx="2"
              :fill="currentStep >= 2 ? '#592466' : '#B5B6BA'"
            />
            <rect
              x="252"
              width="122"
              height="4"
              rx="2"
              :fill="currentStep >= 3 ? '#592466' : '#B5B6BA'"
            />
            <!--rect x="378" width="122" height="4" rx="2" :fill="currentStep === 4 ? '#592466' : '#B5B6BA'"/-->
          </svg>
          <div class="steps-data">
            <span class="steps-data-text">{{ currentStep }}/</span>
            <span class="steps-data-text grey" style="margin-right: 3px"
              >3</span
            >
            <span class="steps-data-text"> {{ getStepName }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentStep: {
      default: 1,
    },

    extraClass: {
      default: "",
    },

    stepsReceived: {
      default: () => {
        return [
          {
            status: "pending",
            title: "SELECCIÓN SEDE Y CURSO",
          },
          {
            status: "pending",
            title: "SELECCIÓN DE HORARIOS",
          },
          {
            status: "pending",
            title: "CONFIRMACIÓN DE CURSOS",
          },
          {
            status: "pending",
            title: "PAGO",
          },
        ];
      },
    },
  },

  computed: {
    programSelectedTitle() {
      return this.$store.state.selectedProgram.name;
    },
    selectedProgram() {
      return this.$store.state.selectedProgram;
    },
    steps() {
      return this.stepsReceived.map((step, index) => {
        if (this.selectedProgram.isPdvX && index === 0) {
          step.title = step.title.replace(/SEDE Y /g, "");
        }
        index = index + 1;
        if (index < this.currentStep) {
          step.status = "completed";
        } else if (index === this.currentStep) {
          step.status = "active";
        } else {
          step.status = "pending";
        }
        return step;
      });
    },
    getStepText() {
      switch (this.currentStep) {
        case 1:
          return "Selecciona el curso que cursarás el 2025 para ver los ";
        case 2:
          return "Selecciona cómo te gustaría estudiar";
        case 3:
          return "Bajo que modalidad";
        default:
          return "";
      }
    },
    getStepName() {
      switch (this.currentStep) {
        case 1:
          return "Curso";
        case 2:
          return "Tipo de Modalidad";
        case 3:
          return "Programa";
        case 4:
          return "Datos";
        default:
          return "";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.steps-recomendador {
  width: 100%;
  display: flex;
  flex-direction: column;

  .content-steps {
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
      margin: 32px 24px 0 24px;
    }
    @media (min-width: 769px) {
      margin: 48px 76px 0 76px;
    }

    .steps-data {
      display: flex;
      margin-top: 8px;
      .steps-data-text {
        font-family: "Poppins-Medium", sans-serif;
        font-size: 16px;
        line-height: 24px;
        color: $morado50;

        &.grey {
          color: $neutral40;
        }
      }
    }
  }
}
</style>

<style scoped lang="scss">
.steps-header {
  padding-top: 218px;
  @include media-breakpoint-down(sm) {
    padding-top: 211px;
  }
}

.steps-container {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  .steps-lines-container {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 1.5px;
    width: 100%;
    background-color: $yellow;

    .step-line {
      height: 1.5px;
      -webkit-box-flex: 1;
      flex-grow: 1;
      &.completed-line {
        background-color: $yellow;
      }
      &:last-child {
        display: none;
      }
    }
  }

  .steps-index-container {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    transform: translateY(-50%);

    .step-index {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      flex-direction: column;
      align-items: center;
      position: relative;
      .step-index-box {
        width: 29px;
        height: 29px;
        position: relative;
        background: $yellow;
        border: 1.2px solid $yellow;
        border-radius: 50%;
        margin-bottom: 3px;
        span {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #fff;
          font-size: 16px;
          font-size: 16px;
          font-weight: bold;
          letter-spacing: -0.23px;
          line-height: 19px;
          text-align: center;
          @include font-medium-regular;
        }
      }
      p {
        font-size: 11px;
        @include alternative-light-regular;
        margin-bottom: 0;
        position: absolute;
        top: 30px;
        left: 50%;
        transform: translateX(-50%);
        width: auto;
        white-space: nowrap;
        @include media-breakpoint-down(sm) {
          display: none;
        }
      }

      &.active {
        .step-index-box {
          background: $black;
          border: 1.5px solid $black;
          span {
            color: #ffffff;
            @include font-bold;
          }
        }
        p {
          @include alternative-bold;
        }
      }

      &.completed {
        .step-index-box {
          background: $yellow;
          border: 1.5px solid transparent;
          span {
            color: #fff;
          }
        }
        p {
          @include alternative-light-regular;
          color: $gray-light;
        }
      }
    }
  }
}

.plan-selected-title {
  span {
    letter-spacing: 3.4px;
    font-size: 13.6px;
    padding: 3px 6px;
    color: gray;
    @include media-breakpoint-down(sm) {
      font-size: 10px;
      padding: 2px 5px;
    }
  }
  h2 {
    font-size: 18.7px;
    line-height: 30px;
    margin-bottom: 0;
    text-transform: uppercase;
    @include font-black-regular;
    color: $red-2-light;
    @include media-breakpoint-down(sm) {
      font-size: 12.5px;
      line-height: 14px;
    }
  }
  &.plan-selected-title-red {
    span {
      background: $red-light;
    }

    h2 {
      color: $red-2-light;
    }
  }

  &.plan-selected-title-purple {
    span {
      background: $purple-light;
    }

    h2 {
      color: $purple;
    }
  }
}
.step-container-number {
  width: 83px;
  height: 83px;
  background: $yellow;
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  @include media-breakpoint-down(sm) {
    display: flex;
    width: 47px;
    height: 47px;
    border-radius: 14px;
  }
}
.step-line-numbers {
  flex: 0 0 218px;
  @include media-breakpoint-down(md) {
    position: relative;
    order: 0;
    margin-top: 15px;
    margin-bottom: 15px;
  }
}
.title-program-col {
  @include media-breakpoint-down(md) {
    margin-top: 12px;
    order: 1;
    height: 81px;
    margin-bottom: 6px;
  }
}
.steps-header-title-container-row {
  @include media-breakpoint-down(md) {
    justify-content: center !important;
    align-items: center;
  }
}
.text-step-header {
  font-size: 25px;
  line-height: 32px;
  letter-spacing: 0.8px;
  text-align: left;
  color: #000;
  margin-bottom: 0;
  @include Gotham-Book;
  @include media-breakpoint-down(sm) {
    font-size: 16px;
    letter-spacing: 0.05px;
    line-height: 20px;
    width: auto;
  }
}
.programs {
  @include Gotham-Black;
  font-size: 25px;
  letter-spacing: 0.08px;
  line-height: 32px;
  @include media-breakpoint-down(sm) {
    font-size: 16px;
    letter-spacing: 0.05px;
    line-height: 20px;
  }
}
.number-indicator-container {
  width: 83px;
  height: 83px;
  margin-right: 28px;
  display: flex;
  @include media-breakpoint-down(sm) {
    display: flex;
    width: 47px;
    height: 47px;
    margin-right: 11px;
  }
}
.text-step-container {
  display: flex;
  width: 726px;
  @include media-breakpoint-down(sm) {
    width: auto;
  }
}
.current-step {
  @include Gotham-Black;
  font-size: 34px;
  letter-spacing: 0.11px;
  line-height: 41px;
  text-align: center;
  color: #000;
  @include media-breakpoint-down(sm) {
    font-size: 24px;
    letter-spacing: 0.08px;
    line-height: 41px;
    text-align: center;
  }
}
.step-header-container {
  width: 837px;
  @include media-breakpoint-down(md) {
    width: 100%;
    justify-content: flex-start;
    align-items: center;
    // padding: 0 0 0 15px;
    margin: 0;
    display: inline-flex;
    flex-wrap: nowrap;
  }
}
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1270px;
  }
}
.text-step-inner-container {
  @include media-breakpoint-down(md) {
    align-items: center !important;
  }
}
</style>
